import { Reducer } from 'redux';
import { IOpenSettingsPanelState, IOpenSettingsPanelAction } from './types';

const initialState = {
  openSettingsPanel: false
}

const OpenSettingsPanelReducer: Reducer<IOpenSettingsPanelState> = ((state: IOpenSettingsPanelState = initialState, action) => {
  switch (action.type) {
    case "OPEN_SETTINGS_PANEL": {
      return { ...state, openSettingsPanel: action.payload }
    }
    default:
      return state
  }
});

export default OpenSettingsPanelReducer;
